import React from "react";
import _ from 'i18n';


const EventProgressBar = ({ progress, number, cycleRegistrant }) => {

  const _progress = progress < 0 || progress > 100 ? 0 : progress;
  return (
    <div
      className='event-stats-progress-wrapper'
    >
      <div
        className='event-stats-progress-bar'
        style={{ width: `${_progress}%` }}
      />
      <div className='event-stats-progress-label'>
        {cycleRegistrant === null ? `${number}` : `${number + cycleRegistrant} (${cycleRegistrant} ${cycleRegistrant > 1 ? _("SUBSCRIBERS") : _("SUBSCRIBER")})`}
      </div>
    </div>
  );
};

export default EventProgressBar;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventProgressBar.js